<template>
  <div class="animated fadeIn">
    <hr />
    <b-row class="mb-3">
      <b-col class="h6 text-muted mb-3">{{  form.identifier }}</b-col>
      <b-col v-if="submission.samples.length > 1" cols="1">
        <b-button @click="$emit('removeSample', sample.test_package_sample_id)" variant="danger" block>
          <i class="fa fa-trash" />
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" class="pt-1">
        Test Pit
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            v-model="form.identifier"
            placeholder="Enter Sample Test Pit"
            :state="!$v.form.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col cols="3">Depth</b-col>
      <b-col class="pr-0">
        <b-form-input
          type="number"
          v-model="sample_septic.depth_start"
          placeholder="Start"
          :state="!$v.sample_septic.depth_start.$invalid"
          invalid-feedback="Required"
        ></b-form-input>
      </b-col>
      <b-col class="pr-0">
        <b-form-input
          type="number"
          v-model="sample_septic.depth_end"
          placeholder="End"
          :state="!$v.sample_septic.depth_end.$invalid"
          invalid-feedback="Required"
        ></b-form-input>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          :value="sample_septic.depth_total"
          placeholder="Total"
          disabled
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" class="pt-1">
        Texture
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            v-model="sample_septic.texture"
            placeholder="Enter Sample Texture"
            :state="!$v.sample_septic.texture.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Sieve Analyte" :label-cols="3">
          <b-form-checkbox
            class="pt-2"
            v-model="sample_septic.sieve"
            :value="1"
            :unchecked-value="0"
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="mb-3">Prismatic</div>
    <b-row>
      <b-col v-if="typeof sample_septic.sar !== 'undefined'">
        <div>SAR</div>
        <b-form-checkbox
          v-model="sample_septic.sar"
          value="1"
          unchecked-value="0"
        >
        </b-form-checkbox>
      </b-col>
      <b-col>
        <div>EC</div>
        <b-form-checkbox
          v-model="sample_septic.ec"
          value="1"
          unchecked-value="0"
        >
        </b-form-checkbox>
      </b-col>
      <b-col>
        <div>COLE</div>
        <b-form-checkbox
          v-model="sample_septic.cole"
          value="1"
          unchecked-value="0"
        >
        </b-form-checkbox>
      </b-col>
      <b-col>
        <div>Dispersion</div>
        <b-form-checkbox
          v-model="sample_septic.dispersion"
          value="1"
          unchecked-value="0"
        >
        </b-form-checkbox>
      </b-col>
    </b-row>
    <div v-if="addOns && addOns.models.length">
      <hr />
      <add-on-select
        :selectedAddOns="add_ons"
        :addOns="addOns"
        @onAddOnSelect="onAddOnSelect"
      ></add-on-select>
    </div>
  </div>
</template>

<script>
import AddOnSelect from "../../AddOnSelect";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const soil_septic = {
  depth_start: null,
  depth_end: null,
  depth_total: null,
  texture: null,
  sieve: null,
  sar: null,
  ec: null,
  cole: null,
  dispersion: null
};

export default {
  name: "SepticSampleFormGroup",
  components: { AddOnSelect },
  mixins: [validationMixin, ToastNotifications],
  props: {
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    sample: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number,
      default: null
    },
    submission: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      form: {
        test_package_sample_id: null,
        identifier: null
      },
      sample_septic: Object.assign({}, soil_septic),
      add_ons: []
    };
  },
  validations: {
    form: {
      identifier: { required }
    },
    sample_septic: {
      depth_start: { required },
      depth_end: { required },
      texture: { required }
    }
  },
  methods: {
    updateTotal() {
      const start = this.sample_septic.depth_start || 0;
      const end = this.sample_septic.depth_end || 0;
      this.sample_septic.depth_total = end > start ? end - start : null;
    },
    onSampleChange() {
      const params = JSON.parse(JSON.stringify(this.form));
      params.sample_septic = this.sample_septic;
      params.add_ons = JSON.parse(JSON.stringify(this.add_ons));
      this.$emit("onSampleChange", {
        sample: params,
        index: this.index
      });
    },
    onAddOnSelect(addOns) {
      if (addOns && addOns.length) {
        this.add_ons = addOns;
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    },
    sample_septic: {
      handler() {
        this.updateTotal();
        this.onSampleChange();
      },
      deep: true
    },
    add_ons: {
      handler() {
        this.onSampleChange();
      },
      deep: true
    }
  },
  created() {
    const sample = JSON.parse(JSON.stringify(this.sample));
    if (sample && sample.test_package_sample_id) {
      this.form.test_package_sample_id =
        typeof sample.test_package_sample_id != "undefined"
          ? sample.test_package_sample_id
          : null;
      this.form.identifier =
        typeof sample.identifier != "undefined" ? sample.identifier : null;
      if (sample.sample_septic) {
        this.sample_septic.depth_start =
          typeof sample.sample_septic.depth_start != "undefined"
            ? sample.sample_septic.depth_start
            : null;
        this.sample_septic.depth_end =
          typeof sample.sample_septic.depth_end != "undefined"
            ? sample.sample_septic.depth_end
            : null;
        this.sample_septic.texture =
          typeof sample.sample_septic.texture != "undefined"
            ? sample.sample_septic.texture
            : null;
        this.sample_septic.sieve =
          typeof sample.sample_septic.sieve != "undefined"
            ? sample.sample_septic.sieve
            : null;
        this.sample_septic.sar =
          typeof sample.sample_septic.sar != "undefined"
            ? sample.sample_septic.sar
            : null;
        this.sample_septic.ec =
          typeof sample.sample_septic.ec != "undefined"
            ? sample.sample_septic.ec
            : null;
        this.sample_septic.cole =
          typeof sample.sample_septic.cole != "undefined"
            ? sample.sample_septic.cole
            : null;
        this.sample_septic.dispersion =
          typeof sample.sample_septic.dispersion != "undefined"
            ? sample.sample_septic.dispersion
            : null;
      }
      this.add_ons = typeof sample.add_ons != "undefined" ? sample.add_ons : [];
    }
  }
};
</script>
